export default {

  props: {
    value: {
      type: null
    },
    rules: {
      type: [Object, String],
      default: ''
    },
    mode: {
      type: [Object, String]
    },
    bails: {
      type: Boolean,
      default: true
    },
    sTag: {
      type: String,
      default: 'select'
    },
    errorMessagesHidden: Boolean
  },

  data () {
    return {
      innerValue: ''
    }
  },

  watch: {
    // Handles internal model changes.
    innerValue (newVal) {
      this.$emit('input', newVal)
    },
    // Handles external model changes.
    value (newVal) {
      this.innerValue = newVal
    }
  },

  created () {
    if (this.value !== null || this.value !== undefined) {
      this.innerValue = this.value
    }
  },

  methods: {
    defChangeHandler () {
      this.$el.dispatchEvent(new CustomEvent('change', { bubbles: true }))
    },
    resolveErrorMessagesHidden (errors) {
      return this.errorMessagesHidden ? null : errors
    },
    isWhat (type) {
      let r = ''
      switch (type) {
        case 'select':
          r = 'v-select'
          break
        case 'autocomplete':
          r = 'v-autocomplete'
          break

        default:
          break
      }
      return r
    }
  }
}
